<template>
<w-sliding-popup ref="slidingPopup" title="데이터베이스 파일정보" :default-content="false" width="800px" @close="onClose">
  <div slot="content" class="body-content-no-scroll" style="height:100%;">
    <el-row type="flex" justify="end" class="title-bar">
      <w-header-search-button @click="searchToolVisible = !searchToolVisible"></w-header-search-button>
    </el-row>
    <el-table-wrapper border style="height:calc(100% - 41px);" :fit-height="true" :data="tableData" :columns="columns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="searchToolVisible">
    </el-table-wrapper>
  </div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';

export default {
  name: 'WSpaceUtilizationTableSpacePopup',
  data() {
    return {
      tableData: [],
      rscKey: null,
      searchToolVisible: false,
      columnDefault,
      columns: [
        {
          prop: 'FILE_NAME',
          label: '물리파일명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'FILE_ID',
          label: '파일 ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'T_KBYTES',
          label: '파일크기(KB)',
          sortable: true,
          formatter: this.convertValue,
        },
        {
          prop: 'T_BLOCKS',
          label: '파일크기(블록)',
          sortable: true,
          formatter: this.convertValue,
        },
        {
          prop: 'STATUS',
          label: '파일상태',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'AUTOEXTENSIBLE',
          label: '자동증가',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'T_MAXBYTES',
          label: '최대크기',
          sortable: true,
          formatter: this.convertValue,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  methods: {
    open(rscKey) {
      this.rscKey = rscKey;
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    onClose() {
      this.rscKey = null;
      this.tableData = [];
    },
    loadData() {
      if (!isNil(this.rscKey)) {
        const params = {
          objId: this.selectedNode.obj.objId,
          queryId: 'DBORTableSpaceFileInfo',
          parameterMap: {
            name: this.rscKey,
          },
        };
        this.loading = true;
        databaseTableInfoAPI.getDbFileInfo(params).then((result) => {
          if (result.data.success === true) {
            this.tableData = result.data.data;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.tableData = [];
      }
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데이터베이스 파일 정보', true));
    },
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/popup/SpaceUtilizationTableSpacePopup.vue